import { createFileRoute } from '@tanstack/react-router'
import { CrosspostTool } from '~/features/crossposting/components/crosspost-tool'

export const Route = createFileRoute('/dashboard/crossposting/$listingId/cross-post')({
  component: CrossPostRoute,
})

function CrossPostRoute() {
  const { listingId } = Route.useParams()
  return <CrosspostTool listingId={listingId} />
}
